const { ZENDESK_WIDGET_KEY } = process.env;
let zendeskWidget = null;
// Zendesk serves Classic or messaging on the same key, depending on the account setting.
// Its widget config tells which one, so we only send the commands that widget supports.
const fetchZendeskWidget = async () => {
    try {
        const response = await fetch(`https://ekr.zdassets.com/compose/${ZENDESK_WIDGET_KEY}`);
        const { products = [] } = await response.json();
        const isClassic = products.some(product => { var _a, _b; return (_b = (_a = product.assets) === null || _a === void 0 ? void 0 : _a.scripts) === null || _b === void 0 ? void 0 : _b.some(script => script.src.includes('/classic/')); });
        return isClassic ? 'classic' : 'messaging';
    }
    catch (error) {
        return 'classic';
    }
};
export const getZendeskWidget = () => {
    if (!zendeskWidget) {
        zendeskWidget = fetchZendeskWidget();
    }
    return zendeskWidget;
};
